import React, { useState, useEffect } from "react";
import { toast } from 'react-toastify';
import Loader from './Loader';
import ApiService from '../services/ApiService';
import { Modal, Button } from 'react-bootstrap';
import ImageUpload from './ImageUpload';

function AddSubTypeQuestion({ test_id, subset_id, updateQuestions, editQuestion, closeModal }) {
  console.log('question-details',subset_id)
  const [isLoader, setIsLoader] = useState(false);
  const [questionDetails, setQuestionDetails] = useState([]);
  const [detailType, setDetailType] = useState('old');
  
  const [formData, setFormData] = useState({
    detail_id: '',
    detail: {
      text: '',
      image: '',
      is_correct: false
    },
    mainQuestion: {
      text: '',
      image: null,
      answer_details: '',
      answer_image: null,
    },
    subQuestions: []
  });

  useEffect(() => {
    getQuestionDetails();
    console.log("editQuestion received:", editQuestion); // 👈 Add this
    if (editQuestion) {
      setFormData({
        detail_id: editQuestion.detail_id || '',
        detail: editQuestion.detail || { text: '', image: '', is_correct: false },
        mainQuestion: {
          text: editQuestion.text || '',
          image: editQuestion.image || null,
          answer_image: editQuestion.answer_image || null,
          answer_details: editQuestion.answer_details || ''

        },
        subQuestions: editQuestion.sub_questions?.map(q => ({
          text: q.text,
          image: q.image || null,
          is_correct: q.is_correct
        })) || []
      });
    } else {
      setFormData(prev => ({
        ...prev,
        subQuestions: [{ text: '', image: null, is_correct: false }]
      }));
    }
  }, [editQuestion]);
  

  const getQuestionDetails = async () => {
    setIsLoader(true);
    try {
      const response = await ApiService.request({
        method: 'GET',
        url: `question-details`,
        data: {'test_id': test_id, 'subset_id': subset_id},
      });
      const data = response.data;
      if (data.status) {
        setQuestionDetails(data.data);
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoader(false);
    }
  };

  // Handle changes to question detail selection
  const handleDetailChange = (e) => {
    const { name, value } = e.target;
    if (name === 'detail_id') {
      const selectedDetail = questionDetails.find(detail => detail.id === value);
      setFormData(prev => ({
        ...prev,
        detail_id: value,
        detail: selectedDetail || { text: '', image: '', is_correct: false }
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };

  // Handle changes to detail text
  const handleDetailTextChange = (e) => {
    const { value } = e.target;
    setFormData(prev => ({
      ...prev,
      detail: {
        ...prev.detail,
        text: value
      }
    }));
  };

  // Handle detail image changes
  const handleDetailImageChange = (file) => {
    setFormData(prev => ({
      ...prev,
      detail: {
        ...prev.detail,
        image: file
      }
    }));
  };

  // Handle changes to main question text
  // Handle changes to main question text and answer details
const handleMainQuestionChange = (e) => {
  const { name, value } = e.target;
  setFormData(prev => ({
    ...prev,
    mainQuestion: {
      ...prev.mainQuestion,
      [name]: value
    }
  }));
};
  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData((prevFormData) => ({
  //     ...prevFormData,
  //     [name]: value,
  //   }));
  // };

  // Handle main question image changes
  const handleMainImageChange = (file) => {
    setFormData(prev => ({
      ...prev,
      mainQuestion: {
        ...prev.mainQuestion,
        image: file
      }
    }));
  };

  // Handle changes to sub-question text
 // Handle changes to sub-question text and radio buttons
 const handleSubQuestionChange = (e, subIndex) => {
  const { name, value } = e.target;

  setFormData(prev => {
    const updatedSubQuestions = [...prev.subQuestions];
    if (name.startsWith("is_correct")) {
      updatedSubQuestions[subIndex].is_correct = value === "true";
    } else {
      updatedSubQuestions[subIndex][name] = value;
    }
    return { ...prev, subQuestions: updatedSubQuestions };
  });
};



  // Handle sub-question image changes
  const handleSubImageChange = (subIndex, file) => {
    setFormData(prev => {
      const updatedSubQuestions = [...prev.subQuestions];
      updatedSubQuestions[subIndex] = {
        ...updatedSubQuestions[subIndex],
        image: file
      };
      return { ...prev, subQuestions: updatedSubQuestions };
    });
  };

  // Add a new sub-question
  const addNewSubQuestion = () => {
    setFormData(prev => ({
      ...prev,
      subQuestions: [
        ...prev.subQuestions,
        { text: '', image: null }
      ]
    }));
  };

  // Remove a sub-question
  const removeSubQuestion = (index) => {
    setFormData(prev => {
      const updatedSubQuestions = [...prev.subQuestions];
      updatedSubQuestions.splice(index, 1);
      return { ...prev, subQuestions: updatedSubQuestions };
    });
  };

  const saveQuestion = async (e) => {
    e.preventDefault();
    setIsLoader(true);
    
    try {
      const data = new FormData();
      data.append('test_id', test_id);
      data.append('subset_id', subset_id);

      // Add question detail data
      data.append('detail_id', formData.detail_id);
      data.append('detail[text]', formData.detail.text);
      if (formData.detail.image) {
        data.append('detail[image]', formData.detail.image);
      }

      // Add main question data
      data.append('text', formData.mainQuestion.text);
      data.append('answer_details', formData.mainQuestion.answer_details);
      data.append('answer_image', formData.mainQuestion.answer_image);
      if (formData.mainQuestion.image) {
        data.append('image', formData.mainQuestion.image);
      }

      // Process each sub-question
      formData.subQuestions.forEach((subQ, subIndex) => {
        data.append(`subQuestions[${subIndex}][text]`, subQ.text);
        if (subQ.image) data.append(`subQuestions[${subIndex}][image]`, subQ.image);
        data.append(`subQuestions[${subIndex}][is_correct]`, subQ.is_correct);
      });

      const response = await ApiService.request({
        method: 'POST',
        url: 'sub-questions/createOrUpdateSubTypeQuestion/' + (editQuestion?.id ?? ''),
        data
      });

      if (response.data.status) {
        toast.success(response.data.message);
        closeModal();
        updateQuestions();
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error(error);
      toast.error('An error occurred while saving the questions');
    } finally {
      setIsLoader(false);
    }
  };
  return (
    <div className="modal fade  show"  style={{ display: 'block',  backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-xl modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h4>{editQuestion ? 'Edit' : 'Add'} Sub Type Questions</h4>
          </div>
          <form onSubmit={saveQuestion}>
            <div className="modal-body">
              <div className="row mb-4">
                {detailType === "new" && (
                  <div className="col-md-2 fv-row fv-plugins-icon-container">
                    <label className="fs-6 fw-semibold mb-2">Image (optional)</label>
                    <ImageUpload
                      onImageChange={handleDetailImageChange}
                      defaultPreviewUrl={formData.detail.image}
                    />
                  </div>
                )}
              </div>
              <div className="main-question-container mb-4 p-3 border rounded">
                <h5 className="mb-3">Main Question</h5>
                <div className="row mb-3">
                  <div className="col-md-10">
                    <label className="required fw-semibold">Question Text</label>
                    <textarea
                      name="text"
                      value={formData.mainQuestion.text}
                      onChange={handleMainQuestionChange}
                      className="form-control"
                      rows={3}
                      placeholder="Enter main question text"
                      required
                    />
                  </div>
                  <div className="col-md-2">
                    <label className="fw-semibold">Question Image 1</label>
                    <ImageUpload
                      onImageChange={handleMainImageChange}
                      defaultPreviewUrl={formData.mainQuestion.image}
                    />
                  </div>
                  
                </div>

                <h5 className="mb-3">Explain Answer</h5>
                <div className="row mb-3">
                  <div className="col-md-10">
                    <label className="required fw-semibold">Explain Answer</label>
                    <textarea
                      name="answer_details"
                      value={formData.mainQuestion.answer_details}
                      onChange={handleMainQuestionChange}
                      className="form-control"
                      rows={3}
                      placeholder="Enter explain answer"
                      required
                    />
                  </div>
                  <div className="col-md-2">
                    <label className="fw-semibold">Question Image</label>
                    <ImageUpload
                      onImageChange={handleMainImageChange}
                      defaultPreviewUrl={formData.mainQuestion.answer_image}
                    />
                  </div>
                </div>
              </div>
              {/* Sub Questions Section */}
              {formData.subQuestions.map((subQuestion, subIndex) => (
                <div key={subIndex} className="sub-question-container mb-4 p-3 border rounded">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5>Sub Question #{subIndex + 1}</h5>
                    <button 
                      type="button" 
                      className="btn btn-sm btn-danger"
                      onClick={() => removeSubQuestion(subIndex)}
                    >
                      Remove
                    </button>
                  </div>

                  <div className="row mb-3">
                    <div className="col-md-8">
                      <label className="required fw-semibold">Question Text</label>
                      <textarea
                        name="text"
                        value={subQuestion.text}
                        onChange={(e) => handleSubQuestionChange(e, subIndex)}
                        className="form-control"
                        rows={3}
                        placeholder="Enter sub question text"
                        required
                      />

                    </div>
                    <div className="col-md-2">
                      <label className="fw-semibold">Question Image</label>
                      <ImageUpload
                        onImageChange={(file) => handleSubImageChange(subIndex, file)}
                        defaultPreviewUrl={subQuestion.image}
                      />
                    </div>
                    <div className="col-md-2">
                    <label className="fs-6 fw-semibold mb-2">Is Correct</label>
                    <div className="d-flex">
                    <div className="form-check">
                    <input
                        id={`is_correct_yes_${subIndex}`}
                        type="radio"
                        name={`is_correct_${subIndex}`}
                        className="form-check-input"
                        checked={subQuestion.is_correct === true || subQuestion.is_correct === 1}
                        value="true"
                        onChange={(e) => handleSubQuestionChange(e, subIndex)}
                      />

                      <label className="form-check-label" htmlFor={`is_correct_yes_${subIndex}`}>Yes</label>
                    </div>

                    <div className="form-check ms-2">
                      <input
                        id={`is_correct_no_${subIndex}`}
                        type="radio"
                        name={`is_correct_${subIndex}`}
                        className="form-check-input"
                        checked={subQuestion.is_correct === false || subQuestion.is_correct === 0}
                        value="false"
                        onChange={(e) => handleSubQuestionChange(e, subIndex)}
                      />
                      <label className="form-check-label" htmlFor={`is_correct_no_${subIndex}`}>No</label>
                    </div>
                    </div>
                  </div>
                  </div>
                </div>
              ))}

              {/* Add Sub Question Button */}
              <div className="text-center mt-3">
                <button 
                  type="button" 
                  className="btn btn-primary"
                  onClick={addNewSubQuestion}
                >
                  Add Sub Type Question
                </button>
              </div>
            </div>
            <div className="modal-footer">
              <Button onClick={closeModal} className="btn btn-secondary">Close</Button>
              <Button type="submit" className="btn btn-base" disabled={isLoader}>
                {isLoader ? <Loader size="30" text="Saving" color="white" /> : 'Save'}
              </Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default AddSubTypeQuestion;